import * as React from "react";
import {useTranslation} from "react-i18next";

const EmptyCart: React.FC = () => {
  const {t} = useTranslation("cart");

  return (
    <div className="center">
      <p>{t("Derzeit befinden sich keine Artikel in Ihrem Warenkorb.")}</p>
      <p>{t("Lassen Sie sich von unserer Produktvielfalt inspirieren.")}</p>
      <p>
        <a className="button" href="/">
          {t("Jetzt Designlieblinge finden")}
        </a>
      </p>
    </div>
  );
};

export default EmptyCart;
